import { render, staticRenderFns } from "./EventDates.vue?vue&type=template&id=49404b0a"
import script from "./EventDates.js?vue&type=script&lang=js&external"
export * from "./EventDates.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports